export default function AccountCreateController(
    $scope,
    articles, // route resolved
    siteService,
    Scroll
) {
    $scope.siteService = siteService;

    if (
        articles.articleItems[0] &&
        articles.articleItems[0].articleSections[0]
    ) {
        let srBodyText = articles.articleItems[0].articleSections[0].bodyHTML;

        srBodyText = srBodyText.replaceAll("<br />", "."); // ... to add some SR pause after headlines HACKLY style
        $scope.srBodyText = srBodyText; // for screen readers

        $scope.sidebarContent = articles.articleItems[0].articleSections[0];
    }
    Scroll.to("main-content-focus", siteService.headerHeight + 15);
}
